import React from 'react';
import { Paper, Typography, Box, Button, Tabs, Tab } from '@mui/material';
import { Download, PieChart, BarChart, TableChart, Timeline, ReportProblem } from '@mui/icons-material';

interface DashboardHeaderProps {
  fileName: string;
  activeTab: string;
  hasReasonData: boolean;
  hasTimeSeriesData: boolean;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  onDownload: () => void;
  isDownloading: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  fileName,
  activeTab,
  hasReasonData,
  hasTimeSeriesData,
  onTabChange,
  onDownload,
  isDownloading,
}) => {
  return (
    <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5">
          手指衛生データ分析: {fileName}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Download />}
            onClick={onDownload}
            disabled={isDownloading}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {isDownloading ? 'ダウンロード中...' : 'データ出力'}
          </Button>
        </Box>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          aria-label="dashboard tabs"
          centered
          sx={{
            '& .MuiTab-root': {
              fontSize: '1.1rem',
              fontWeight: 500,
            },
          }}
        >
          <Tab label="概要" value="overview" icon={<PieChart />} iconPosition="start" />
          <Tab label="遵守率" value="compliance" icon={<BarChart />} iconPosition="start" />
          <Tab label="詳細分析" value="analysis" icon={<TableChart />} iconPosition="start" />
          {hasTimeSeriesData && (
            <Tab label="時系列分析" value="timeseries" icon={<Timeline />} iconPosition="start" />
          )}
          {hasReasonData && (
            <Tab
              label="未実施理由"
              value="reason"
              icon={<ReportProblem />}
              iconPosition="start"
            />
          )}
        </Tabs>
      </Box>
    </Paper>
  );
};
